



















































































import { bus } from "@/bus";
import i18n from "@/i18n";
import { MacrosCountInEnum, fixedHtmlData, Macros, MacrosTypeEnum, MacrosOptions } from "@/services/posts/postTypes/fixedhtml";
import { Time } from "@/services/posts/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import FunctionalCalendar from "vue-functional-calendar/src/components/FunctionalCalendar.vue";
import { calendarConfigs } from "@/services/functional-calendar";
@Component({
    components: {
        "functional-calendar": FunctionalCalendar
    }
})
export default class MacrosComponentForm extends Vue {
    @Prop() vsid!: string;
    countTimeSpan = "";
    // Variables with default value
    defaultTime = "00:00";
    showMacrosOptions = false;
    timeLists = Time
    macros = {
        type: this.properties.macros.type,
        countIn: this.properties.macros.countIn,
        date: this.properties.macros.date || new Date().toDateString(),
        time: this.properties.macros.time || this.defaultTime,
        macrosOptions: this.properties.macros.macrosOptions as MacrosOptions
    } as Macros;

    get properties(): fixedHtmlData {
        return ((this.$parent as any).localProperties.data).filter((x: fixedHtmlData) => x.id === this.vsid)[0];
    }

    get isMacrosOptionsEnabled() {
        return this.showMacrosOptions;
    }

    get CalendarDateLabel() {
        return i18n.d(new Date(this.macros.date), "short");
    }

    get calendarConfigs() {
        return calendarConfigs();
    }

    get calendarDate() {
        return {
            currentDate: new Date(),
            selectedDate: new Date(this.macros.date)
        };
    }

    get isCountInDays(): boolean {
        return this.macros.countIn === MacrosCountInEnum.days;
    }

    get isCountUp(): boolean {
        return this.macros.type === MacrosTypeEnum.countUp;
    }

    get dropDownMacrosTypes(): any[] {
        return Object.values(MacrosTypeEnum).map(key => ({ name: i18n.t(`posts.macros.${key}`), id: key }));
    }

    get dropDownMacrosCountIn(): any[] {
        return Object.values(MacrosCountInEnum).map(key => ({ name: i18n.t(`posts.macros.${key}`), id: key }));
    }

    get macrosType(): any {
        return this.macros.type;
    }

    get macrosCountIn(): any {
        return this.macros.countIn;
    }

    get macrosTime(): string {
        return this.macros.time;
    }

    get getSelectedDateAndTime(): moment.Moment {
        const selectedDate = moment(this.macros.date).format("YYYY-MM-DD");
        const mergedDateTime = moment(`${selectedDate} ${this.macros.time}`);
        return moment.utc(mergedDateTime);
    }

    set macrosType(selectedType: any) {
        this.resetOptionsValueToDefault();
        this.macros.type = selectedType.id;
    }

    set macrosCountIn(selectedCountIn: any) {
        this.macros.countIn = selectedCountIn.id;
    }

    set calendarDate(date: any) {
        const dateParts = date.selectedDate.split("/");
        // month is 0-based, that's why we need dataParts[1] - 1
        const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        this.macros.date = dateObject.toDateString();
    }

    set macrosTime(selectedTime: string) {
        if (!selectedTime) {
            return;
        }
        this.macros.time = selectedTime;
    }

    // Lifecycles Hooks
    mounted() {
        bus.$on("getComponentData", () => {
            this.properties.macros = this.macros;
        });

        this.$watch("isMacrosOptionsEnabled", (updated) => {
            if (updated) {
                if (this.isMacrosOptionsEnabled) {
                    (this.$refs.macrosCalendarDate as any).clickDay({
                        date: moment(this.macros.date).format("D/M/YYYY"),
                        isMarked: true
                    });
                }
            }
        });
        this.getDateAndTime();
    }

    destroyed() {
        bus.$off("getComponentData");
    }

    // Methods

    getDateAndTime() {
        var calculatedDate = "";
        switch (this.macros.type) {
        case MacrosTypeEnum.countDown:
            calculatedDate = this.countdownInterval();
            break;
        case MacrosTypeEnum.countUp:
            calculatedDate = this.countupInterval();
            break;
        default:
            break;
        }
        if (calculatedDate === "") {
            switch (this.macros.countIn) {
            case MacrosCountInEnum.days:
                calculatedDate = "0";
                break;
            case MacrosCountInEnum.daysWithTime:
                calculatedDate = "00:00:00";
                break;
            default:
                break;
            }
        }
        this.countTimeSpan = calculatedDate;
        setTimeout(() => {
            this.getDateAndTime();
        }, 1000);
    }

    countdownInterval(): string {
        var countDownTimeSpan = "";
        var currentTime = moment().utc();
        var countDownEndDate = this.getSelectedDateAndTime;
        if (countDownEndDate.isSameOrAfter(currentTime)) {
            var duration = moment.duration(countDownEndDate.diff());
            var countDownTime = duration.asMilliseconds();
            var countDownDays = Math.floor(duration.asDays());
            countDownTimeSpan = this.formatCountDateAndTime(countDownTime, countDownDays);
        }
        return countDownTimeSpan;
    }

    countupInterval(): string {
        var timeHasPassed = "";
        var currentTime = moment().utc();
        var countUpStartDate = this.getSelectedDateAndTime;
        if (countUpStartDate.isSameOrBefore(currentTime)) {
            var secondsDiff = currentTime.diff(countUpStartDate, "seconds");
            var countUpTime = moment.duration(secondsDiff, "seconds").asMilliseconds();
            var countUpDays = Math.floor(moment.duration(secondsDiff, "seconds").asDays());
            timeHasPassed = this.formatCountDateAndTime(countUpTime, countUpDays);
        }
        return timeHasPassed;
    }

    formatCountDateAndTime(countTime: any, countDays:any): string {
        var formatedCountDateAndTime = "";
        switch (this.macros.countIn) {
        case MacrosCountInEnum.days:
            formatedCountDateAndTime = String(countDays);
            break;
        case MacrosCountInEnum.daysWithTime:
            formatedCountDateAndTime = String(countDays).padStart(2, "0") + moment.utc(countTime).format(":HH:mm");
            break;
        default:
            break;
        }
        return formatedCountDateAndTime;
    }

    resetOptionsValueToDefault() {
        this.macros.date = new Date().toDateString();
        this.macros.time = this.defaultTime;
        (this.$refs.macrosCalendarDate as any).clickDay({
            date: moment(this.macros.date).format("D/M/YYYY"),
            isMarked: true
        });
    }
}

